import { render, staticRenderFns } from "./PatientModal__Style#Drawer.vue?vue&type=template&id=2dca3d2e&scoped=true&"
import script from "./PatientModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./PatientModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./PatientModal__Style#Drawer.vue?vue&type=style&index=0&id=2dca3d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca3d2e",
  null
  
)

export default component.exports